import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, API } from "@/App";
import { toast } from "sonner";
import axios from "axios";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        toast.error("فشل المصادقة");
        navigate("/login");
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        // Exchange session_id for user data
        const response = await axios.post(`${API}/auth/google/session`, {
          session_id: sessionId
        }, { withCredentials: true });

        login(response.data.user, response.data.access_token);
        toast.success("تم تسجيل الدخول بنجاح!");
        
        // Clear the hash and navigate
        window.history.replaceState(null, '', window.location.pathname);
        navigate("/dashboard", { replace: true });
      } catch (error) {
        console.error("Auth error:", error);
        toast.error("فشل تسجيل الدخول");
        navigate("/login");
      }
    };

    processAuth();
  }, [login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--background))]">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[hsl(var(--primary))] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-[hsl(var(--foreground))] font-medium">جاري تسجيل الدخول...</p>
      </div>
    </div>
  );
}
